import { get } from "../../utils/object-helpers";

$ {
    const title = get(input, "containers.0.title", null);
    const cards = state.cards;
    let cardLayout;
    if (cards.length === 1) {
        cardLayout="layout-one";
    } else if (cards.length === 2) {
        cardLayout="layout-two";
    } else {
        cardLayout="layout-three";
    }
}

<div class=`str-promoted-items ${state.navOpen ? 'str-promoted-items--open' : 'str-promoted-items--closed'}`>
    <div class=`str-promoted-items__cards str-promoted-items__cards--${cardLayout}`>
        <for|card, idx| of=cards>
            <str-adaptive-card ...card page=input.page class=card._type cardLayout=cardLayout />
        </for>
    </div>
</div>
